function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e903d301-3e9d-4fd0-aa03-84234e5fb318{fill:none;stroke:#f65e5c;stroke-width:10.04px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "a1236b59-61fa-421a-b4cd-42dc97aea9a8",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "a303ee8e-8281-4812-96d1-dd0b3475877a",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "e903d301-3e9d-4fd0-aa03-84234e5fb318",
  points: "111.35 246.42 6.65 125.72 111.35 5.02 118.05 5.02 56.35 125.72 118.05 246.42 111.35 246.42"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "e903d301-3e9d-4fd0-aa03-84234e5fb318",
  points: "199.35 246.42 94.65 125.72 199.35 5.02 206.05 5.02 144.35 125.72 206.05 246.42 199.35 246.42"
})));

var SvgLogoIcon7 = function SvgLogoIcon7(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 214.25 251.44",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoIcon7, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-icon (7).1400b3b1.svg";
export { ForwardRef as ReactComponent };